(function(window, angular, undefined) {
    angular.module('formApp')
    .directive("apostropheFormat", [function() {
        return {
            restrict: "A",
            require:'ngModel',
            link: function($scope, element,ctrl,ngModel) {
                ngModel.$parsers.push(function (value) {
                    //Due to update in IOS with default smart punctuation
                    //Convert curly apostrophe to normal to avoid errors
                    //set global flag to replace all matches
                    var nonCurly = value.replace(/(['’‘`])/g, "'");
                    return nonCurly;
                });
            }
        };
    }]);
})(window, window.angular);